/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ConfigurationType = "MeetingColors" | "PersonalCalendarSync" | "SettingUpTeam" | "SettingUpWorkingHours" | "ShadowCalendar" | "SlackStatusSync" | "TravelTime" | "%future added value";
export type SuggestionActionResultType = "Autopilot" | "ConfigureSettings" | "Decline" | "Fyi" | "Invite" | "RemoveAttendee" | "RequestToMove" | "Reschedule" | "ViewMeeting" | "ViewProfile" | "ViewTeamDashboard" | "%future added value";
export type SuggestionType = "AutopilotAttendee" | "ChromeExtensionTip" | "ConflictingMeeting" | "ExpensiveMeeting" | "ExpensiveOrganizer" | "LowFocusTime" | "MeetingNotOnAutopilot" | "MissingAttendance" | "MissingUserConfiguration" | "RecurringOneOnOneOrganizer" | "RunningOutOfFocusTime" | "Shell" | "TeammateOutOfOffice" | "WeekInReview" | "WeeklyAutopilotSummary" | "%future added value";
export type TipType = "CheckOutProfile" | "CheckOutRescheduler" | "CheckOutTeamDashboard" | "FeedWelcome" | "%future added value";
export type SuggestionCard_feedSuggestion = {
    readonly id: string;
    readonly suggestionId: string | null;
    readonly suggestionType: SuggestionType | null;
    readonly suggestionPayload: {
        readonly __typename: string;
        readonly tipType?: TipType | null | undefined;
        readonly configurationType?: ConfigurationType | null | undefined;
        readonly " $fragmentRefs": FragmentRefs<"SuggestionBody_suggestionPayload">;
    } | null;
    readonly primaryAction: {
        readonly type: SuggestionActionResultType | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionAction_feedSuggestion" | "SuggestionCardHeader_feedSuggestion">;
    readonly " $refType": "SuggestionCard_feedSuggestion";
};
export type SuggestionCard_feedSuggestion$data = SuggestionCard_feedSuggestion;
export type SuggestionCard_feedSuggestion$key = {
    readonly " $data"?: SuggestionCard_feedSuggestion$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionCard_feedSuggestion">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuggestionCard_feedSuggestion",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "suggestionId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "suggestionType",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "suggestionPayload",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SuggestionBody_suggestionPayload"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tipType",
                            "storageKey": null
                        }
                    ],
                    "type": "SuggestionResultChromeExtensionTipPayload",
                    "abstractKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "configurationType",
                            "storageKey": null
                        }
                    ],
                    "type": "SuggestionResultMissingUserConfigurationPayload",
                    "abstractKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "SuggestionActionResult",
            "kind": "LinkedField",
            "name": "primaryAction",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionAction_feedSuggestion"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionCardHeader_feedSuggestion"
        }
    ],
    "type": "FeedSuggestion",
    "abstractKey": null
} as any;
(node as any).hash = '43d3afb81aef29635a1dc2d6915c8bf7';
export default node;
